/**
 * The firm a platform staff member acts in through the Firm API. A firm's
 * staff act in their own firm and see no picker.
 */

import { For, Show, createResource, createRoot } from "solid-js";

import { api } from "../lib/api";
import { chooseFirm, firmId } from "../lib/firm";

/** The firms platform staff choose from: ONE list, for the picker and for the
 *  page that makes a firm. Asked for on first use, never at import. */
let firmList: ReturnType<typeof readFirms> | undefined;

function readFirms() {
  return createRoot(() => createResource(() => api.listOrganizations()));
}

function firms() {
  firmList ??= readFirms();
  return firmList;
}

/** Read the firms again (one was just made); resolves to the fresh list. */
export async function refetchFirms() {
  return firms()[1].refetch();
}

export default function FirmPicker() {
  const [list] = firms();
  return (
    <Show when={list()}>
      {(loaded) => (
        <select
          class="select"
          aria-label="Firm"
          value={firmId() ?? ""}
          onInput={(e) => {
            const chosen = loaded().organizations.find((org) => org.org_id === e.currentTarget.value);
            chooseFirm(chosen ? { orgId: chosen.org_id, governance: chosen.governance } : null);
          }}
        >
          <option value="">Choose a firm…</option>
          <For each={loaded().organizations}>
            {(firm) => <option value={firm.org_id}>{firm.name}</option>}
          </For>
        </select>
      )}
    </Show>
  );
}

/** Whether `role` must choose a firm before the Firm API answers. */
export function needsFirm(role: string): boolean {
  return role === "noctant_superadmin" && firmId() === null;
}
